
  export default {
    props: {
      mobileFilterSearchButton: { type: Boolean, default: false },
      mobileFilterButtonString: { type: String, default: '' },
      showExtraFilters: { type: Boolean, default: false }
    },
    computed: {
      filterDisplay () {
        return this.$store.getters['utils/getFilterDisplay'];
      },
      filterExtraDisplay () {
        return this.$store.getters['utils/getFilterExtraDisplay'];
      }
    },
    methods: {
      showFilterDisplay () {
        this.$store.commit('utils/setFilterDisplay', true);
        this.$store.commit('utils/setFilterExtraDisplay', false);
      },
      showFilterExtraDisplay () {
        this.$store.commit('utils/setFilterExtraDisplay', true);
        this.$store.commit('utils/setFilterDisplay', false);
      }
    }
  };
